import { FC, PropsWithChildren } from 'react';
import { Box, BoxProps } from '@mui/material';


interface Props extends Omit<BoxProps, 'p' | 'padding' | 'py' | 'px' | 'paddingY' | 'paddingX'> {};

export const BoxWell: FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props;
  const boxProps = { ...props, sx: { ...props.sx } };

  return (
    <Box
      {...boxProps}
      sx={{
        py: 2,
        px: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '12px',
        backgroundColor: '#fafafb',
        ...boxProps.sx,
      }}
    >
      {children}
    </Box>
  );
};
